import React from 'react';
import './NftSupply.css'
const NftSupply = () => {
    return (
      <div className="max-width">
        <div className="css-pa8sx ">
          <div className="css-1qphp4s">
            <svg
              preserveAspectRatio="none"
              className="governance-landing-key-stats-border-svg"
              width="100%"
              height={399}
              viewBox="0 0 343 399"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x={1}
                y={1}
                width={341}
                height={397}
                rx={11}
                stroke="url(#paint0_radial_3097_22172)"
                strokeWidth={2}
              />
              <defs>
                <radialGradient
                  id="paint0_radial_3097_22172"
                  cx={0}
                  cy={0}
                  r={1}
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(171.5) rotate(90) scale(353.115 219.538)"
                >
                  <stop stopColor="#6B78EE" />
                  <stop offset={1} stopColor="#FD5CB7" stopOpacity={0} />
                </radialGradient>
              </defs>
            </svg>
          </div>
          <div className="css-1trerm7">
            <svg
              preserveAspectRatio="none"
              width="100%"
              height={244}
              viewBox="0 0 720 244"
              className="governance-landing-key-stats-border-svg"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x={1}
                y={1}
                width={718}
                height={242}
                rx={11}
                stroke="url(#paint0_radial_3088_22262)"
                strokeWidth={2}
              />
              <defs>
                <radialGradient
                  id="paint0_radial_3088_22262"
                  cx={0}
                  cy={0}
                  r={1}
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(360) rotate(90) scale(215.94 460.838)"
                >
                  <stop stopColor="#6B78EE" />
                  <stop offset={1} stopColor="#FD5CB7" stopOpacity={0} />
                </radialGradient>
              </defs>
            </svg>
          </div>
          <div className="css-41grjw">
            <svg
              className="governance-landing-key-stats-border-svg"
              preserveAspectRatio="none"
              width="100%"
              height={200}
              viewBox="0 0 1200 200"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2C6.47715 2 2 6.47715 2 12V188C2 193.523 6.47714 198 12 198H1188C1193.52 198 1198 193.523 1198 188V12C1198 6.47715 1193.52 2 1188 2H12ZM12 0C5.37258 0 0 5.37258 0 12V188C0 194.627 5.37257 200 12 200H1188C1194.63 200 1200 194.627 1200 188V12C1200 5.37258 1194.63 0 1188 0H12Z"
                fill="url(#paint0_radial_3366_22537)"
              />
              <defs>
                <radialGradient
                  id="paint0_radial_3366_22537"
                  cx={0}
                  cy={0}
                  r={1}
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(600) rotate(90) scale(177 768.063)"
                >
                  <stop stopColor="#6B78EE" />
                  <stop offset={1} stopColor="#FD5CB7" stopOpacity={0} />
                </radialGradient>
              </defs>
            </svg>
          </div>
          <div className="css-1qphp4s">
            <svg
              className="governance-landing-key-stats-bg-svg"
              preserveAspectRatio="none"
              width="100%"
              height={399}
              viewBox="0 0 343 399"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_7679_62101)">
                <g opacity="0.3" filter="url(#filter0_f_7679_62101)">
                  <ellipse
                    cx="171.5"
                    cy={48}
                    rx="185.5"
                    ry={240}
                    fill="url(#paint0_linear_7679_62101)"
                    fillOpacity="0.8"
                  />
                </g>
              </g>
              <rect
                x={1}
                y={1}
                width={341}
                height={397}
                rx={11}
                stroke="url(#paint1_radial_7679_62101)"
                strokeWidth={2}
              />
              <defs>
                <filter
                  id="filter0_f_7679_62101"
                  x={-158}
                  y={-336}
                  width={659}
                  height={768}
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity={0} result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feGaussianBlur
                    stdDeviation={72}
                    result="effect1_foregroundBlur_7679_62101"
                  />
                </filter>
                <linearGradient
                  id="paint0_linear_7679_62101"
                  x1="-71.7111"
                  y1={-292}
                  x2="388.957"
                  y2="-267.358"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.142994" stopColor="#E05FBB" />
                  <stop offset={1} stopColor="#4250F4" />
                </linearGradient>
                <radialGradient
                  id="paint1_radial_7679_62101"
                  cx={0}
                  cy={0}
                  r={1}
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(171.5) rotate(90) scale(353.115 219.538)"
                >
                  <stop stopColor="#6B78EE" />
                  <stop offset={1} stopColor="#FD5CB7" stopOpacity={0} />
                </radialGradient>
                <clipPath id="clip0_7679_62101">
                  <rect width={343} height={399} fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="css-15riy0p">
            <svg
              className="governance-landing-key-stats-bg-svg"
              preserveAspectRatio="xMinYMin"
              width="100%"
              height={200}
              viewBox="0 0 1200 200"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_3430_23345)">
                <g opacity="0.3" filter="url(#filter0_f_3430_23345)">
                  <ellipse
                    cx={600}
                    cy="-54.5"
                    rx={550}
                    ry="128.5"
                    fill="url(#paint0_linear_3430_23345)"
                    fillOpacity="0.8"
                  />
                </g>
              </g>
              <defs>
                <filter
                  id="filter0_f_3430_23345"
                  x={-94}
                  y={-327}
                  width={1388}
                  height={545}
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity={0} result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feGaussianBlur
                    stdDeviation={72}
                    result="effect1_foregroundBlur_3430_23345"
                  />
                </filter>
                <linearGradient
                  id="paint0_linear_3430_23345"
                  x1="-121.111"
                  y1="-236.542"
                  x2="1138.17"
                  y2="136.474"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.142994" stopColor="#E05FBB" />
                  <stop offset={1} stopColor="#4250F4" />
                </linearGradient>
                <clipPath id="clip0_3430_23345">
                  <rect width={1200} height={200} fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="governance-landing-key-stats-column-wrap">
            <div className="governance-landing-key-stats-column">
              <div data-bn-type="text" className="css-peba8t">
                Total SAPI Staked
              </div>
              <div data-bn-type="text" className="css-c7kicv">
                N/A
              </div>
            </div>
            <div className="governance-landing-key-stats-column">
              <div className="css-1aog95r">
                <div data-bn-type="text" className="css-wiwtne">
                  % Of Supply Staked
                </div>
              </div>
              <div data-bn-type="text" className="css-c7kicv">
                N/A
              </div>
            </div>
            <div className="governance-landing-key-stats-column">
              <div className="css-1aog95r">
                <div data-bn-type="text" className="css-wiwtne">
                  Average Locked Period
                </div>
              </div>
              <div data-bn-type="text" className="css-c7kicv">
                N/A
              </div>
            </div>
            <div className="governance-landing-key-stats-column">
              <div data-bn-type="text" className="css-peba8t">
                SAPI Stakers
              </div>
              <div data-bn-type="text" className="css-c7kicv">
                N/A
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default NftSupply;
